export const setWindowInstance = (windowInstance) => ({
  type: 'SET_WINDOW_INSTANCE',
  windowInstance,
})

export const setEnvelopeId = (envelopeId, imageViewerDln) => {
  // console.log(envelopeId, imageViewerDln)
  return ({
  type: 'SET_ENVELOPE_ID',
  envelopeId,
  imageViewerDln: imageViewerDln
})}

export const setRequestOpen = (requestOpen) => ({
  type: 'SET_REQUEST_OPEN',
  requestOpen,
})

export const openImageViewer = () => ({
  type: 'SET_REQUEST_OPEN',
  requestOpen: true,
})

export const openSpecificImage = (envelopeId, imageViewerDln) => ({
  type: 'OPEN_SPECIFIC_IMAGE',
  envelopeId,
  imageViewerDln,
})